import requestDefault from '@/shared/utils/request';

export const agree = (agreementIds: number[], assignPlatform?: number)
: Promise<boolean> => requestDefault
  .postGate<boolean>(
    'f.contract.authorization.agree',
    {
      agreementIds,
      assignPlatform,
    },
  );

const AuthorizationApi = {
  agree,
};

export default AuthorizationApi;
